module.exports = __webpack_public_path__ + "static/1-6512eaa0d223d055cfa87eb8d19752ad.jpg";